import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IGameSate } from "../state";
 import { mapToCardGame } from "../../memory-game-card/mapper/store-object-to-model-instance-mapper";

export const selectGameState = createFeatureSelector<IGameSate>('gameState');

// Selector memoryCardState
export const selectMemoryCardState = createSelector(
  selectGameState,
  (state: IGameSate) => state.memoryCardState
);

// Selecteur sur la carte qui est à trouver
export const selectCardToFindInGameState = createSelector(
  selectGameState,
  (state: IGameSate) => state.memoryCardState.cardGame.cardToFindInGame
);

// Selecteur sur la carte qui est à trouver
export const selectCardGameState = createSelector(
  selectGameState,
  (state: IGameSate) => state.memoryCardState.cardGame
);

export const isGameLoadingSelector = createSelector(selectMemoryCardState, (state) => state.isGameLoading);
export const isLoadingSuccessSelector = createSelector(selectMemoryCardState, (state) => state.isLoadingSuccess);
export const returnCardInGameSelector = createSelector(selectMemoryCardState, (state) => state.cardInGame);
export const isGameReadyToPlaySelector = createSelector(selectMemoryCardState, (state) => state.isGameReadyToPlay);

export const cardGameSelector = createSelector(selectCardGameState, (state) => mapToCardGame(state));
export const cardsSelector = createSelector(selectCardGameState, (state) => state.cards);
export const timeToObserveBeforeStartSelector = createSelector(selectCardGameState, (state) => state.timeCountDown.timeToObserveBeforeStart);
export const isTimeCountDownVisibleSelector = createSelector(selectCardGameState, (state) => state.timeCountDown.isCountDownVisible);
export const cardToFindQuantitySelector = createSelector(selectCardGameState, (state) => state.cardToFindQuantity);
export const isGameFinishSelector = createSelector(selectCardGameState, (state) => state.isGameFinish);
export const isGameWinSelector = createSelector(selectCardGameState, (state) => state.isGameWin);
export const badResponseCumulatedSelector = createSelector(selectCardGameState, (state) => state.badResponseCumultated);

export const isCardToFindVisibleSelector = createSelector(selectCardToFindInGameState, (state) => state.isCardVisible);
export const cardToFindInGameSelector = createSelector(selectCardToFindInGameState, (state) => state);

export const selectCardById = (id: number) =>
  createSelector(selectCardGameState, (state) => state.cards.find(card => card.id === id));
